var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataUploadWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning_amber"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0005 4.99228L16.276 15.8349H3.72492L10.0005 4.99228ZM10.0005 1.66699L0.833008 17.5017H19.1679L10.0005 1.66699ZM10.8339 13.3347H9.16705V15.0015H10.8339V13.3347ZM10.8339 8.33423H9.16705V11.6678H10.8339V8.33423Z",
    fill: "#CD4326"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataUploadWarning);
export default __webpack_public_path__ + "static/media/data-upload-warning.ab842826f2261a879b92fc880161a104.svg";
export { ForwardRef as ReactComponent };